angular
    .module('octopusApp.shared')
    .service('selectorDirective', function() {
        function isMultipleSelector(attrs) {
            return attrs["multiple"] === "" || (!!attrs["multiple"] && attrs["multiple"] !== "false");
        }

        function isAllowedToClear(attrs) {
            return attrs["allowClear"] === "" || (!!attrs["allowClear"] && attrs["allowClear"] !== "false");
        }

        this.build = function(defaultPlaceholder, options) {
            options = options || {};
            return {
                restrict: 'E',
                replace: true,
                require: 'ngModel',
                scope: {
                    placeholder: "=",
                    available: "="
                },
                templateUrl: 'areas/shared/views/selector/select-projects.html',
                controller: function($scope) {
                    var vm = this;

                    if (vm.isMultiple && !vm.selected){
                        vm.selected = [];
                    }
                    // Set Default Placeholder
                    if (!vm.placeholder || vm.placeholder === ''){
                        vm.placeholder = defaultPlaceholder;
                    }

                    vm.showControl = function showControl() {
                        return !!vm.available && (!vm.isMultiple || !!vm.selected);
                    };
                },
                compile: function($element, attrs) {
                    var isMultiple = isMultipleSelector(attrs);
                    var canClear = isAllowedToClear(attrs);
                    var $uiSelect = $("ui-select", $element);
                    var $uiSelectChoices =  $("ui-select-choices", $element);
                    var $uiSelectMatch = $("ui-select-match", $element);

                    // Needs to be explicitly reapplied due to remapping of model
                    if (attrs.hasOwnProperty('noDirtyCheck')) {
                        $uiSelect.attr('no-dirty-check', '');
                    }

                    if (isMultiple) {
                        $uiSelect.attr("multiple", "true");
                    }

                    if (!canClear) {
                        $uiSelectMatch.attr("allow-clear", "false");
                    }

                    if (options.choiceTemplate) {
                        $uiSelectChoices.html(options.choiceTemplate);
                    }

                    if (options.selectedTemplate) {
                        var template = options.selectedTemplate;
                        if (!isMultiple) {
                            template = options.selectedTemplate.replace(/\$item/g, '$select.selected');
                        }
                        $uiSelectMatch.html(template);
                    }

                    if (options.isSimple) {
                        $uiSelectChoices.attr('repeat', $uiSelectChoices.attr('repeat').replace('item.Id as ', ''));
                        $uiSelectMatch.html($uiSelectMatch.html().replace('.Name', ''));
                        $uiSelectChoices.html($uiSelectChoices.html().replace('.Name', ''));
                    }

                    if (options.boundIdentity){
                        $uiSelectChoices.attr('repeat', $uiSelectChoices.attr('repeat').replace('item.Id as ', 'item.'+ options.boundIdentity +' as '));
                    }

                    return {
                        post: function ($scope, $element, attrs, ngModel) {
                            var vm = $scope.vm;
                            vm.isMultiple = isMultiple;
                            ngModel.$render = function onRender() { // Update internal selected if outer model changes
                                vm.selected = ngModel.$viewValue || (isMultiple ? [] : null);
                            };
                            vm.onChange = function onChange() { // Update outer model if internal model changes
                                ngModel.$setViewValue(vm.selected);
                            };
                        }
                    };
                },
                controllerAs: 'vm',
                bindToController: true
            };
        };
    })
    .directive('selectCustom', function(selectorDirective) {
        return selectorDirective.build('Select');
    }).directive('selectProjects', function(selectorDirective) {
        return selectorDirective.build('Any Project');
    }).directive('selectEnvironments', function(selectorDirective) {
        return selectorDirective.build('Any Environment');
    }).directive('selectTenants', function(selectorDirective) {
        return selectorDirective.build('Select Tenants');
    }).directive('selectChannels', function(selectorDirective) {
        return selectorDirective.build('Any Channel');
    }).directive('selectProjectGroups', function(selectorDirective) {
        return selectorDirective.build('Any Project Group');
    }) .directive('selectRoles', function(selectorDirective) {
        return selectorDirective.build('Any Role', {
            isSimple: true
        });
    }) .directive('selectTags', function(selectorDirective) {
        return selectorDirective.build('Select Tags', {
            choiceTemplate: '<span class="label label-info" ng-style="{ \'background-color\' : item.Color }" ng-bind-html="item.Name | highlight: $select.search" ></span>',
            selectedTemplate: '<span set-select-match-color uib-tooltip="{{$item.Description}}">{{$item.Name}}</span>',
            boundIdentity: 'CanonicalTagName'
        });
    }).directive('selectUsers', function(selectorDirective) {
        return selectorDirective.build('Any User',
            {
                choiceTemplate: '<span ng-bind-html="item.Username | highlight: $select.search"></span> (<span ng-bind-html="item.DisplayName | highlight: $select.search"></span>)',
                selectedTemplate:  '{{$item.DisplayName}} ({{$item.Username}})'
            });
    }).directive('selectRelease', function (selectorDirective) {
        return selectorDirective.build('Show current releases',
            {
                choiceTemplate: '<span ng-bind-html="item.Version | highlight: $select.search"></span>',
                selectedTemplate:  '{{$item.Version}}'
            });
    });

angular
    .module('octopusApp.shared').directive('setSelectMatchColor', function() {
    return {
        restrict: 'EA',
        link: function ($scope, $element) {
            var item = $element.scope().$item;

            if (item) {
                $element.parents(".ui-select-match-item")
                    .css("background-color", item.Color);
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/select-project.js
// module id = 599
// module chunks = 1